import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const plaid = defineConnector({
  identifier: "plaid",
  name: "Plaid",
  tagLine: "Financial data aggregation",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://[^/]*\\.plaid\\.com/.*",
  auth: customAuth("plaid"),
  steps: [
    {
      title: "Get your Plaid API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Plaid Dashboard](https://dashboard.plaid.com/developers/keys) and copy your **Client ID** and **Secret**.\n\nChoose the environment that matches your use case: Sandbox for testing, Development for limited live data, or Production for full access.",
        },
      ],
    },
    {
      title: "Select your environment",
      items: [
        {
          kind: "select",
          label: "Environment",
          required: true,
          options: [
            { value: "sandbox", label: "Sandbox (testing)" },
            { value: "development", label: "Development" },
            { value: "production", label: "Production" },
          ],
          defaultValue: "sandbox",
          target: { kind: "configuration", field: "environment" },
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Your Plaid client ID",
          required: true,
          target: { kind: "configuration", field: "clientId" },
        },
        {
          kind: "input",
          label: "Secret",
          placeholder: "Your Plaid secret",
          required: true,
          target: { kind: "secrets", field: "secret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://sandbox.plaid.com/institutions/get",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        client_id: "{clientId}",
        secret: "{secret}",
        count: 1,
        offset: 0,
        country_codes: ["US"],
      }),
    }),
  },
});
